<style src="./Research.scss" lang="scss" scoped></style>
<template>
  <section class="research">
    <content-header path="Research"/>

    <ul class="card-list-container">
      <li
        class="card-list-item size-200x400"
        @click="jumpToRoute('ResearchStock')"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'stock', action: 'SHOW'})">

        <icon-menu-stock />
        <h3>Estoque</h3>
      </li>

      <li
        class="card-list-item size-200x400"
        @click="jumpToRoute('ResearchCmed')"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'cmed', action: 'SHOW'})">

        <icon-menu-price-tag />
        <h3>CMED</h3>
      </li>

      <li
        class="card-list-item size-200x400"
        @click="jumpToRoute('ItemAnalysis')"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'stock', action: 'SHOW'})">

        <icon-menu-stock />
        <h3>Análise de Item</h3>
      </li>
    </ul>
  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import {IconMenuStock,
        IconMenuPriceTag } from '@/components/primitives/icons'

export default {
  name: 'Research',
  components: {
    ContentHeader,
    IconMenuStock,
    IconMenuPriceTag
  },
  data () {
    return {}
  },
  methods: {
    jumpToRoute (name) {
      this.$router.push({ name })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/research/Research.vue